import { FC } from 'react';
import { Link, matchPath, useHistory } from 'react-router-dom';

import { Sidebar, SideNav } from '@servicetitan/design-system';

import { releases } from '../assets/releases';

export const ReleaseListSidebar: FC = () => {
    const releaseNotesPath = '/docs/release-notes';
    const history = useHistory();
    const match = matchPath<{ version: string }>(
        history.location.pathname,
        `${releaseNotesPath}/:version`,
    );

    return (
        <Sidebar localStorageKey="sidebar:docs">
            <SideNav title={<Link to="/docs/release-notes">Release Notes</Link>}>
                {releases.map(release => (
                    <SideNav.Item
                        key={release.version}
                        active={release.version === match?.params.version}
                        onClick={() => {
                            document.querySelector('.Page__page')!.scrollTo(0, 0);
                            history.push(`${releaseNotesPath}/${release.version}`);
                        }}
                    >
                        {`ST-${release.version}`}
                    </SideNav.Item>
                ))}
            </SideNav>
        </Sidebar>
    );
};
ReleaseListSidebar.displayName = 'ReleaseListSidebar';
